import { api } from './client';

export type KycStatus = 'NONE' | 'PENDING' | 'APPROVED' | 'REJECTED';

export interface KycStatusResponse {
  status: KycStatus;
  submission: null | {
    id: string;
    submittedAt: string;
    decidedAt: string | null;
    adminNotes: string | null;
    documentType: string;
    fullName: string;
    dateOfBirth: string;
    countryCode: string;
  };
}

export const kycApi = {
  status: () => api<KycStatusResponse>('/api/kyc/status'),

  submit: (form: FormData) =>
    api<{ submissionId: string; status: KycStatus }>('/api/kyc/submit', {
      method: 'POST',
      body: form,
      isMultipart: true,
    }),
};
